import axios from "axios";
import { getField, updateField } from "vuex-map-fields";
import i18n from "@/i18n";
import Vue from "vue";

export default {
    namespaced: true,
    state: {
        isLoadingMainWidgetParameters: true,
        mainWidgetParameters: []
    },
    getters: {
        getField, //vuex-map-fields
    },
    mutations: {
        updateField, //vuex-map-fields
    },
    actions: {
        remove({ commit, state, dispatch }, payload) {
            return axios
                .delete(this._vm.$apiURL + "/main-widget-parameters/" + 'all')
                .then((response) => {
                    if (response.data.status === "success") {
                        this._vm.$inform(this._vm.i18n.t("common.operation_success"));
                    }
                })
                .catch((error) => {
                    dispatch("common/showError", { error: error }, { root: true });
                });
        },
        async store({ commit, state, dispatch }, payload) {
            updateField(state, { path: "isLoadingMainWidgetParameters", value: true });
            return await axios
                .post(this._vm.$apiURL + "/main-widget-parameters", payload)
                .then((response) => {
                    if(response.data && response.data.status === "success" && response.data.updated) {
                        this._vm.$inform(this._vm.i18n.t("common.operation_success"));
                        //commit('updateInState', response.data.updated)
                    }
                    return response.data.updated;
                })
                .catch((error) => {
                    dispatch("common/showError", { error: error }, { root: true });
                    return false;
                })
                .finally(() => {
                    updateField(state, { path: "isLoadingMainWidgetParameters", value: false });
                });
        },
        async get({ commit, state, dispatch }, payload){
            updateField(state, { path: "isLoadingMainWidgetParameters", value: true });
            return axios
                .get(this._vm.$apiURL + "/main-widget-parameters")
                .then((response) => {
                    updateField(state, { path: "mainWidgetParameters", value: response.data });
                })
                .catch((error) => {
                    dispatch("common/showError", { error: error }, { root: true });
                })
                .finally(() => {
                    updateField(state, { path: "isLoadingMainWidgetParameters", value: false });
                });
        }
    },
}
